import { getUserAccount, getUserData } from '../user/selectors';
import { getGamedayAccount } from '../gamedayAccount/selectors';

export const FEATURE_NEW_CART_API_ACCOUNTS = 'NewCartApiAccounts';

export const FEATURE_ADDRESS_V2_ACCOUNTS = 'AddressV2Accounts';

export const SEC_ACCOUNTS = 'SECAccounts';

// Returns true if provided {accountNumber} is white-listed for the specified feature
// NOTE: If {accountNumber} not provided, uses current user's account number
export const accountNumberHasFeature = (state, accountNumber, featureName, envConfigKey) => {
  // Environment config override flag
  // TODO: replace import.meta.env[envConfigKey] with full string before using
  //  See: https://vitejs.dev/guide/env-and-mode.html#production-replacement
  if (import.meta.env[envConfigKey] === 'false') return false;

  const allowedAccounts = state.feature && state.feature[featureName];
  // Enable all accounts if 'all' found in array of allowed accounts
  if (allowedAccounts && allowedAccounts.some(acc => acc.toLowerCase() === 'all')) return true;

  const account = getUserAccount(state);

  return !!account && !!allowedAccounts && allowedAccounts.some(acc => acc === (accountNumber || account.number));
};

// Returns true if provided {acccountEmail} is white-listed for the specified feature
// NOTE: If {acccountEmail} not provided, uses current users's email
export const accountEmailHasFeature = (state, acccountEmail, featureName, envConfigKey) => {
  // Environment config override flag
  // TODO: replace import.meta.env[envConfigKey] with full string before using
  //  See: https://vitejs.dev/guide/env-and-mode.html#production-replacement
  if (import.meta.env[envConfigKey] === 'false') return false;

  const allowedAccounts = state.feature && state.feature[featureName];
  // Enable all accounts if 'all' found in array of allowed accounts
  if (allowedAccounts && allowedAccounts.some(acc => acc.toLowerCase() === 'all')) return true;

  const account = getUserData(state);

  return !!account && !!allowedAccounts && allowedAccounts.some(acc => acc === (acccountEmail || account.email));
};

// Returns true if provided {userId} is white-listed for the specified feature
// NOTE: If {userId} not provided, uses current users's id
export const userIdHasFeature = (state, accountId, featureName, envConfigKey) => {
  // Environment config override flag
  // TODO: replace import.meta.env[envConfigKey] with full string before using
  // See: https://vitejs.dev/guide/env-and-mode.html#production-replacement
  if (import.meta.env[envConfigKey] === 'false') return false;

  const allowedAccounts = state.feature && state.feature[featureName];
  // Enable all accounts if 'all' found in array of allowed accounts
  if (allowedAccounts && allowedAccounts.some(acc => acc.toLowerCase() === 'all')) return true;

  const account = getUserData(state);

  return !!account && !!allowedAccounts && allowedAccounts.some(acc => acc === (accountId || account.id));
};

// Checks if it's an SEC MANA Testing Account
export const getIsSECAccount = state => {
  const secAccounts = state.feature.get(SEC_ACCOUNTS) || [];
  return secAccounts.includes('all') || secAccounts.includes(getGamedayAccount(state)?.accountNumber);
};
